import React, { forwardRef, useState } from 'react';
import NeedAnalysisResult from './NeedAnalysisResult';
import IncomeDetails from './IncomeDetails';
import DebtDetails from './DebtDetails';
import SavingDetails from './SavingDetails';
import Button from '@material-ui/core/Button';
import { Col, Modal } from 'react-bootstrap';
import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

const CoverageAmountPopUpContent = forwardRef((props, ref) => {
    const [showbutton, setshowbutton] = useState(true);
    const [currentStep, setCurrentStep] = useState(0);
    const [showPopUp, setShowPopUp] = useState(false);
    const [finalNeed, setFinalNeed] = useState({
        immediateNeeds: null,
        longTermNeeds: null,
        totalNeeds: null,
        savings: null,
        existingInsurance: null,
        spouseEarnings: null,
        totalResources: null,
        finalResult: null,
    });

    const [coverageQuestions, setCoverageQuestions] = useState({
        totalIncome: null,
        spouseIncome: null,
        incomeNeeded: 10,
        funeralIncome: 10000,
        morgage: null,
        otherDebt: null,
        monthlyDebt: null,
        educationExpense: null,
        numberOfChildren: null,
        totalSaving: null,
        existingInsurance: null,
    });

    const onShowButon = () => {
        setshowbutton(false);
    }

    const onButtonClick = (button) => {
        switch (button) {
            case 'Income':
                setCurrentStep(0);
                break;
            case 'Debt':
                setCurrentStep(1);
                break;
            case 'Saving':
                setCurrentStep(2);
                break;
            case 'Next':
                if (currentStep === 2) {
                    let finalResult = calculateCoverageAmountNeeds();
                    setFinalNeed(finalResult)
                }
                setCurrentStep(currentStep + 1);
                break;
            default:
                break;
        }
    }

    const calculateCoverageAmountNeeds = () => {
        var insuranceNeededRounded = 0;
        var immediateNeeds = Number(coverageQuestions.funeralIncome) + Number(coverageQuestions.morgage) + Number(coverageQuestions.otherDebt)

        var yearsToReplace = Number(coverageQuestions.incomeNeeded);
        var desiredNetIncomeNeeded = Number(coverageQuestions.totalIncome) - (12 * Number(coverageQuestions.monthlyDebt));

        var desiredIncomeShortfall = desiredNetIncomeNeeded - Number(coverageQuestions.spouseIncome);
        if (desiredIncomeShortfall < 0) {
            desiredIncomeShortfall = 0;
        }

        var investedLumpSumToCoverIncomeGap = desiredIncomeShortfall * (Math.pow((1.03), yearsToReplace) - 1) / (Math.pow((1.03), yearsToReplace) * .03);

        var totalCollege = Number(coverageQuestions.educationExpense) * Number(coverageQuestions.numberOfChildren);

        var longTermNeeds = investedLumpSumToCoverIncomeGap + totalCollege + Number(coverageQuestions.educationExpense) + (Number(coverageQuestions.spouseIncome) * yearsToReplace);

        var totalNeeds = immediateNeeds + longTermNeeds;

        var totalResources = Number(coverageQuestions.totalSaving) + Number(coverageQuestions.existingInsurance) + (Number(coverageQuestions.spouseIncome) * yearsToReplace);

        var insuranceNeeded = totalNeeds - totalResources;

        if (insuranceNeeded < 0) {
            insuranceNeeded = 0;
        }

        insuranceNeededRounded = GlobalRoundAccuracy(Number(insuranceNeeded), 5000);

        let resultObj = {};
        resultObj.immediateNeeds = immediateNeeds
        resultObj.longTermNeeds = longTermNeeds
        resultObj.totalNeeds = totalNeeds
        resultObj.savings = Number(coverageQuestions.totalSaving)
        resultObj.existingInsurance = Number(coverageQuestions.existingInsurance)
        resultObj.spouseEarnings = Number(coverageQuestions.spouseIncome)
        resultObj.totalResources = totalResources
        resultObj.finalResult = insuranceNeededRounded
        return resultObj;
    }

    const GlobalRoundAccuracy = (num, acc) => {
        return Math.round(Number(num) * (1 / Number(acc))) * acc;
    }

    const onFieldChange = (name, value) => {
        setCoverageQuestions({ ...coverageQuestions, [name]: value })
    }

    const onApply = (value) => {
        props.onFieldChange(Number(value));
        props.onHide();
    }

    return (
        <div ref={ref}>
            <div className='div-show mt-3'>
                <h3>Help Me Decide: {props.heading}</h3>
                <p className='py-1 my-3'>{props.details} </p>
            </div>
            {showbutton ? <div className='help-decide p-3' ><h4>Need help deciding?</h4>
                <p>Just answer a few simple questions and get a quick needs analysis.</p>
                <div className='button-hide'><Button variant='contained' color='primary' onClick={onShowButon} >Get Started</Button></div></div> :
                <React.Fragment>
                    <div className='help-decide pl-3 button-hide'>
                        {
                            currentStep > 0 &&
                            <Button variant='outlined' color='primary' onClick={() => onButtonClick('Income')} className='mr-3 my-3 px-2 py-1'>Income</Button>
                        }
                        {
                            currentStep > 1 &&
                            <Button variant='outlined' color='primary' onClick={() => onButtonClick('Debt')} className='mr-3 my-3 px-2 py-1'>Debt</Button>
                        }
                        {
                            currentStep > 2 &&
                            <Button variant='outlined' color='primary' onClick={() => onButtonClick('Saving')} className='mr-3 my-3 px-2 py-1'>Saving</Button>
                        }
                        {
                            currentStep < 3 &&
                            <Button variant='contained' color='primary' onClick={() => onButtonClick('Next')} className='my-3' >Next</Button>
                        }
                    </div>
                    {
                        currentStep === 0 &&
                        <React.Fragment>
                            <h4 className='mt-2'>Income Needs</h4>
                            <p className='mt-2'>Type in a value for each input below.</p>
                            <IncomeDetails onFieldChange={(name, value) => onFieldChange(name, value)} state={coverageQuestions} setShowPopUp={() => setShowPopUp(true)} />
                        </React.Fragment>
                    }
                    {
                        currentStep === 1 &&
                        <React.Fragment>
                            <h4 className='mt-2'>Debt and Expenses</h4>
                            <p className='mt-2'>Type in a value for each input below.</p>
                            <DebtDetails onFieldChange={(name, value) => onFieldChange(name, value)} state={coverageQuestions} />
                        </React.Fragment>
                    }
                    {
                        currentStep === 2 &&
                        <React.Fragment>
                            <h4 className='mt-2'>Savings and Existing Insurance</h4>
                            <p className='mt-2'>Type in a value for each input below.</p>
                            <SavingDetails onFieldChange={(name, value) => onFieldChange(name, value)} state={coverageQuestions} />
                        </React.Fragment>
                    }
                    {
                        currentStep === 3 &&
                        <React.Fragment>
                            <h4 className='mt-2'>Needs Analysis Result</h4>
                            <NeedAnalysisResult onFieldChange={(name, value) => onFieldChange(name, value)} state={coverageQuestions} finalNeed={finalNeed} onApply={(value) => onApply(value)} />
                        </React.Fragment>
                    }
                    <Modal show={showPopUp} onHide={() => setShowPopUp(false)} animation={false} centered size='md'>
                        <Modal.Header className='pb-0'>
                            <Modal.Title>Total Income Needed</Modal.Title>
                            <IconButton className="close-button" aria-label="close" onClick={() => setShowPopUp(false)}>
                                <CloseIcon />
                            </IconButton>
                        </Modal.Header>
                        <Modal.Body>
                            <Col>
                                <p className='pt-1'>Enter the total annual income your family would need if you were to die today. This value should represent the minimum amount you need to maintain your current lifestyle. If you are unsure, just enter your current income.</p>
                            </Col>
                        </Modal.Body>
                    </Modal>
                </React.Fragment>
            }
        </div>
    )
})

export default CoverageAmountPopUpContent;


// WEBPACK FOOTER //
// ./src/components/Product/TermLifeInsurance/PopUps/CoverageAmountPopUp/CoverageAmountPopUpContent.js